import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { OfferModal } from "@Src/components/OfferModal";
import { useOfferModal } from "@Src/hooks/useOfferModal";
import { getContextModalData } from "@Src/redux/reducers/offerModal/offerModalSelectors";
import {
  DealsContext,
  getContextByState,
  initialDealsContext,
} from "@Src/routes/deals/Deals.context";

/**
 * OfferModalContext - Single instance modal that renders based on Redux state
 */
const OfferModalContext = () => {
  const { isOpen, storeKey, props } = useSelector(getContextModalData);
  const { closeModal } = useOfferModal();
  const [dealsContext, setDealsContext] = useState({ ...initialDealsContext });

  const setDealsContextCallback = useCallback((newContext) => {
    setDealsContext((prevContext) => ({ ...prevContext, ...newContext }));
  }, []);

  // Don't render anything if modal is closed or no store key
  if (!isOpen || !storeKey) {
    return null;
  }

  return (
    <DealsContext.Provider value={getContextByState(dealsContext, setDealsContextCallback)}>
      <OfferModal store_key={storeKey} closeModal={closeModal} {...props} />
    </DealsContext.Provider>
  );
};

export default OfferModalContext;
